export default function Logo({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
      <circle cx="24" cy="24" r="23" fill="var(--forest)" />
      <path
        d="M24 38V22m0 6-6-5m6 1 6-5m-6 11-8-4"
        stroke="var(--parchment)"
        strokeWidth="2.2"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="24" cy="16" r="5" fill="var(--accent)" />
      <circle cx="15" cy="21" r="3.6" fill="var(--leaf-light)" />
      <circle cx="33" cy="21" r="3.6" fill="var(--leaf-light)" />
      <circle cx="14" cy="31" r="3" fill="var(--leaf-light)" />
    </svg>
  );
}
